<app-page-header title="function.Users"  translateTitle="yes" icon="people"></app-page-header>
<div [@fadeInOut] class="page-content">

  <div class="flex-row flex-col-ltsm gap-col-1em">
    <mat-form-field class="flex-1">
      <mat-label>{{'globalTexts.SearchInstruction' | translate}}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)">
    </mat-form-field>
  </div>

  <div class="mat-elevation-z8">
    @if (loadingIndicator) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }
    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="isEnabled">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'users.management.IsEnabled' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.isEnabled | boolYesNoTranslator}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="userName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'users.management.UserName' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.userName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fullName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'users.management.FullName' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.fullName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'users.management.Email' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.email}} </mat-cell>
      </ng-container>

      @if (canManageUsers) {
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="flex-100px justify-center">
          </mat-header-cell>
          <mat-cell *matCellDef="let user" class="flex-100px justify-center">
            <button mat-icon-button matTooltip="{{'commands.Edit' | translate}}" (click)="editUser(user)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button matTooltip="{{'commands.Delete' | translate}}" (click)="confirmDelete(user)">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
      }

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>

    <mat-paginator hidePageSize="true" pageSize="20" [pageSizeOptions]="[5, 10, 25, 100]" class="customPaginator"></mat-paginator>

    @if (canAssignRoles) {
      <section class="button-container">
        <button mat-fab color="primary" matTooltip="{{'commands.Add' | translate}}" (click)="editUser()"><mat-icon>add</mat-icon></button>
      </section>
    }

  </div>
</div>
